import * as shippingoptions from 'smg/customer-api/shippingoptions';

export const Get = shippingoptions.ShippingOptions;
export const New = shippingoptions.NewShippingOption;
